<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import Button from 'dashboard/components-next/button/Button.vue';
import AgentConversationItem from './AgentConversationItem.vue';
import NewAgentChatModal from './NewAgentChatModal.vue';

const { t } = useI18n();
const conversations = useMapGetter('agentConversations/getConversations');
const showModal = ref(false);
</script>

<template>
  <div
    class="flex flex-col flex-shrink-0 bg-n-surface-1 relative w-[240px] 2xl:w-[280px]"
  >
    <div
      class="flex items-center justify-between gap-2 px-3 h-[3.25rem] border-b border-n-weak"
    >
      <span class="text-base font-medium truncate text-n-slate-12">
        {{ t('AGENT_CHAT.TITLE') }}
      </span>
      <Button
        v-tooltip="t('AGENT_CHAT.NEW_CONVERSATION')"
        icon="i-lucide-pencil"
        ghost
        sm
        @click="showModal = true"
      />
    </div>
    <div class="flex-1 overflow-y-auto">
      <AgentConversationItem
        v-for="conv in conversations"
        :key="conv.id"
        :conversation="conv"
      />
      <div
        v-if="!conversations.length"
        class="flex flex-col items-center justify-center h-40 gap-2 text-n-slate-10 text-sm"
      >
        <fluent-icon icon="chat-multiple" size="24" />
        <p>{{ t('AGENT_CHAT.NO_CONVERSATIONS') }}</p>
      </div>
    </div>
    <NewAgentChatModal v-if="showModal" @close="showModal = false" />
  </div>
</template>
